<template>
    <component :is="template">
        <ConfirmPasswordInput v-if="!confirm" @confirm="confirm = true"/>
        <div v-else>
            <div class="tit-wrap tit-wrap--unberline">
                <h2 class="tit">회원정보수정</h2>
            </div>
    
            <div class="table-style table-style--default">
                <div class="table-style__row">
                    <div class="table-style__th">아이디</div>
                    <div class="table-style__td">
                        <v-row class="row--x-small">
                            <v-col cols="12">
                                <v-text-field v-model="me.username" v-bind="$attrs" placeholder="아이디" outlined hide-details disabled/>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <div class="table-style__row">
                    <div class="table-style__th">비밀번호</div>
                    <div class="table-style__td">
                        <v-row class="row--x-small">
                            <v-col cols="12">
                                <v-password-field v-model="me.currentPassword" v-bind="$attrs" placeholder="현재비밀번호" autocomplete="new-password" outlined hide-details  />
                            </v-col>
                            <v-col cols="12">
                                <v-password-field v-model="me.password" v-bind="$attrs" placeholder="변경할 비밀번호" autocomplete="new-password" outlined hide-details />
                            </v-col>
                            <v-col cols="12">
                                <v-password-field v-model="me.password2" v-bind="$attrs" placeholder="변경할 비밀번호확인" autocomplete="new-password" outlined hide-details />
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
    
            <div class="mt-10px mb-20px mt-md-20px mb-md-30px">
                <v-btn large color="primary" outlined @click="certificate" class="mr-2" >본인인증 등록</v-btn>
                <v-icon v-if="me.ci" color="#5eb86c">mdi-shield-lock-open-outline</v-icon>
            </div>
    
            <v-divider />
    
            <div class="table-style table-style--default">
                <div class="table-style__row">
                    <div class="table-style__th">이름</div>
                    <div class="table-style__td">
                        <v-row class="row--x-small">
                            <v-col cols="12" md="6">
                                <v-text-field v-model="me.name" v-bind="$attrs" placeholder="이름" outlined hide-details disabled/>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <div class="table-style__row">
                    <div class="table-style__th">연락처</div>
                    <div class="table-style__td">
                        <v-row align="center" class="row--x-small">
                            <v-col cols="12">
                                <v-row align="center" class="row--small">
                                    <v-col>
                                        <v-select v-model="me.phone1" v-bind="$attrs" placeholder="연락처" :items="appendPhones" outlined hide-details disabled />
                                    </v-col>
                                    <v-col cols="auto">-</v-col>
                                    <v-col>
                                        <v-text-field v-model="me.phone2" v-bind="$attrs" outlined hide-details disabled maxlength="4"/>
                                    </v-col>
                                    <v-col cols="auto">-</v-col>
                                    <v-col>
                                        <v-text-field v-model="me.phone3" v-bind="$attrs" outlined hide-details disabled maxlength="4"/>
                                    </v-col>
                                    <v-col cols="12" md="auto">
                                        <v-checkbox v-model="me.smsEnabled" label="수신동의" class="mt-4" ></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <div class="table-style__row">
                    <div class="table-style__th">이메일</div>
                    <div class="table-style__td">
                        <v-row align="center" class="row--small">
                            <v-col>
                                <v-text-field v-model="me.email1" v-bind="$attrs" placeholder="이메일" outlined hide-details />
                            </v-col>
                            <v-col cols="auto">@</v-col>
                            <v-col>
                                <v-text-field v-model="me.email2" v-bind="$attrs" outlined hide-details />
                            </v-col>
                            <v-col cols="auto">-</v-col>
                            <v-col>
                                <v-select v-model="me.email3" v-bind="$attrs" :items="prependEmails" item-text="text" item-value="value" outlined hide-details @input="me.email2 = me.email3" />
                            </v-col>
                            <v-col cols="12" md="auto" class="mt-4">
                                <v-checkbox v-model="me.emailEnabled" label="수신동의" ></v-checkbox>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <div class="table-style__row">
                    <div class="table-style__th">주소</div>
                    <div class="table-style__td">
                        <v-row class="row--x-small">
                            <v-col md="6">
                                <v-text-field v-model="me.postcode" v-bind="$attrs" placeholder="우편번호" outlined readonly hide-details @click="$refs.daumPostcode.open()" />
                            </v-col>
                            <v-col cols="auto">
                                <v-btn large block color="primary" class="v-btn--input" @click="$refs.daumPostcode.open()" >주소검색</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="12">
                                <v-text-field v-model="me.address1" v-bind="$attrs" placeholder="기본주소" outlined readonly hide-details @click="$refs.daumPostcode.open()" />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="me.address2" v-bind="$attrs" placeholder="상세주소" outlined hide-details />
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
    
            <div class="mt-20px mt-md-30px">
                <v-row align="center" class="row--small">
                    <v-col cols="auto">
                        <v-btn small outlined color="primary" @click="withdraw" >회원탈퇴</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <div class="font-size-14 primary--text">* 회원탈퇴 유의사항 - 현재 보유중인 캐시 및 포인트가 전부 소멸 됩니다.</div>
                    </v-col>
                </v-row>
            </div>
    
            <div class="mt-20px mt-md-30px">
                <v-row align="center" class="row--small">
                    <v-spacer/>
                    <v-col cols="auto">
                        <v-btn large color="primary" @click="save" >저장</v-btn>
                    </v-col>
                </v-row>
            </div>
        </div>

        <kcb-cert ref="kcbCert" />
        <login-dialog ref="loginDialog" />
        <daum-postcode ref="daumPostcode" @input="({ postcode, address }) => { me.postcode = postcode; me.address1 = address; }" />
    </component>
</template>
<script>
import api from "@/api";
import { mdiShieldLockOpenOutline } from '@mdi/js';
import KcbCert from "@/components/plugins/kcb/kcb-cert.vue";
import LoginDialog from "@/components/client/login/login-dialog.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
import CryptoAES from "@/plugins/crypto-aes";
import ConfirmPasswordInput from "@/components/client/mypage/confirm-password-input";
import { resyncAfterPasswordChange } from "@/plugins/push";
export default {
    components: {
        ConfirmPasswordInput,
        KcbCert,
        VPasswordField,
        DaumPostcode,
        LoginDialog,
    },
    data(){
        return {
            mdiShieldLockOpenOutline,

            me: {},

            appendPhones: ["010", "011", "016", "017", "019"],
            prependEmails: [
                { text: ":: 직접입력 ::", value: null },
                { text: "naver.com", value: "naver.com" },
                { text: "gmail.com", value: "gmail.com" },
                { text: "daum.net", value: "daum.net" },
                { text: "hanmail.net", value: "hanmail.net" },
            ],
            disable: true,

            confirm: false
        }
    },
    async mounted(){
        await this.init();
        // await this.mount();
    },
    methods: {
        async init(){
            let { me } = await api.v1.me.profile.get();
            let [ phone1, phone2, phone3 ] = me.phone?.split?.("-") || [];
            let [ email1, email2 ] = me.email?.split?.("@") || {};

            this.me = {
                ...me,
                phone1, phone2, phone3,
                email1, email2, email3: null,
                password: '',
                password2: ''
            }
        },
        // 로컬 테스트용
        // async getAccessToken(){
        //     await this.$store.dispatch("refresh", { refreshToken: this.refreshToken, _cert: "622af4183dae29e48d8a3e08" });
        //     alert(this.$store.state.payload);
        //     alert(this.$store.state.scope);
        // },
        async certificate(){
            if(this.me.ci) return alert('본인인증에 등록된 회원입니다')
            this.$refs.kcbCert.$off();
            this.$refs.kcbCert.$on("input", async ({ _cert }) => {
                let result = await api.v1.me.certificate({ _cert });
                await this.init()
                if (result.success) {
                    alert('본인인증이 등록되었습니다')
                }
            });
            this.$refs.kcbCert.open();
        },
        login(){
            return new Promise((resolve, reject) => {
                if(this.logon) resolve();
                else{
                    this.$refs.loginDialog.$off();
                    this.$refs.loginDialog.$on("login", _ => resolve());
                    this.$refs.loginDialog.$on("cancel", _ => reject());
                    this.$refs.loginDialog.open();
                }
            });
        },
        async userCertificate(){
            return new Promise((resolve, reject) => {
                if(this.scope?.includes?.("cert")) resolve();
                else {
                    this.$refs.kcbCert.$off();
                    this.$refs.kcbCert.$on("input", async ({ _cert }) => {
                        console.log(_cert)
                        await this.$store.dispatch("refresh", { refreshToken: this.refreshToken, _cert });
                        resolve();
                    });

                    this.$refs.kcbCert.open();
                }
            });
        },
        validate(){
            try{
                if(this.me.password && !this.me.currentPassword) throw new Error("비밀번호를 변경하기위해서는 현재비밀번호를 입력해주세요")
                if(!this.me.password && this.me.currentPassword) throw new Error("변경할 비밀번호를 입력해주세요")
                if(this.me?.password?.match(/ /)) throw new Error("비밀번호에 공백은 제외해서 입력해주세요");
                if(this.me.password != this.me.password2) throw new Error("비밀번호·비밀번호확인이 일치하지 않습니다");
                if(this.me.password && (0 <= this.me.password.indexOf(this.me.username) || !this.me.password.match(/[0-9]/) || !this.me.password.match(/[a-zA-Z]/) || !this.me.password.match(/[`~!@#$%^&*()\-_=+\[\]{};:'",.<>\/\?]/) || this.me.password.length < 8 || 20 < this.me.password.length )) throw new Error("비밀번호는 회원 아이디와 동일하지 않아야 하며 영어+숫자+특수문자 혼합 문자로 최소 8~20자리입니다");
                if(this.me.email1.match(/[@'"`(){}\[\]]/) || this.me.email1.substr(-1) == '.') throw new Error("이메일 양식을 확인해주세요")
                if(!this.me.email2.match(/[.]/) || this.me.email2.match(/[^0-9a-zA-Z.]/)) throw new Error("이메일 양식을 확인해주세요");
                return true;
            }
            catch(error){
                alert(error.message);
                return false;
            }
        },
        async save(){
            let me = this.me;
            if(this.validate()){
                // 현재 비밀번호와 새 비밀번호가 둘 다 있을 때만 서버가 비밀번호를 바꾸고 푸시 토큰을 전부 지운다(me.controller.js)
                let passwordChanged = !!(me.password && me.currentPassword);
                await api.v1.me.profile.put({
                    ...me,
                    password: me.password ? CryptoAES.encrypt(me.password) : null,
                    password2: undefined,
                    phone: [me.phone1, me.phone2, me.phone3].join("-"),
                    email: [me.email1, me.email2].join("@")
                });

                // 서버가 지운 이 브라우저의 푸시 토큰을 다시 등록한다(로그아웃하지 않으므로)
                if(passwordChanged) resyncAfterPasswordChange();

                alert("저장되었습니다");
                this.init();
            }
        },
        async withdraw(){
            if(confirm("회원탈퇴 시 기존 ID로 재가입이 불가능하며 보유하고 계신 포인트와 캐시는 삭제되고 환불 및 반환 처리가 불가능합니다. 또한, 3개월 이내에 재가입이 불가능합니다. 그래도 회원탈퇴 하시겠습니까? ")){
                await api.v1.me.withdraw();
                await this.$store.dispatch("logout");

                alert("이용해주셔서 감사합니다");

                this.$router.push(`/`);
            }
        }
    },
    computed: {
        template(){
            return () => import(`@/templates/${this.$theme.pages.mypage}`);
        },
        refreshToken(){ 
            return this.$store.state.refreshToken;
        },
        accessToken(){ 
            return this.$store.state.accessToken; 
        },
        scope(){
            return this.$store.state.scope;
        },
        logon(){ 
            return !!this.accessToken;
        },
    }
}
</script>

<style scoped>
.member-profile .title {
    font-size: 22px !important;
    font-weight: 600;
}
</style>